import { lazy } from 'react'

export default {
    path: '/righe/:rigaId',
    title: 'Riga: {{params.rigaId}}',
    component: lazy(() => import('./detail'))
}